import React from 'react';
import { styled } from 'linaria/react';
import { elevateAutocompleteTitleStyle } from './ElevateAutocompleteTitleStyle';
import { Link } from 'react-router-dom';
import t from '@jetshop/intl';
import { theme } from '../../../Theme';
const ElevateContentListTypeWrapper = styled('div')`
  color: #191c1d;
  font-size: 14px;
  font-weight: 400;

  ${theme.below.md} {
    h2 {
      margin-bottom: 8px;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 10px;

    ${theme.below.md} {
      gap: 6px;
    }

    a {
      color: inherit;
      text-decoration: none;

      :hover {
        text-decoration: underline;
      }
    }
  }
`;

export const ElevateContentListType = ({ items, title, clickCallback }) => {
  return (
    <ElevateContentListTypeWrapper>
      <h2 className={elevateAutocompleteTitleStyle}>{t(title)}</h2>
      <ul>
        {items?.map(item => (
          <li key={item?.ticket}>
            <Link to={item?.link} onClick={() => clickCallback(item)}>
              {item?.title}
            </Link>
          </li>
        ))}
      </ul>
    </ElevateContentListTypeWrapper>
  );
};
